const {Component} = require("react");
const PropTypes = require("prop-types");
const deepAssign = require("deep-assign");
const stripe = require("services/stripe");
const Promise = require("es6-promise");

/*
 -------------------------------
 Default options
 -------------------------------
 */

const defaultOptions = {
	supportedCountries: ['SEPA'],
	placeholderCountry: 'DK',
	base: {
		fontSize: '16px',
		color: "#122432",
		fontSmoothing: 'antialiased',
		fontFamily: 'Proxima Nova',
		letterSpacing: '.5px',
		lineHeight: '45px',
		'::placeholder': {
			color: '#122432',
		},
	},
	invalid: {
		color: '#e5424d',
		':focus': {
			color: '#303238',
		},
	},
	complete: {
		color: '#2ECC71',
		':focus': {
			color: '#2ECC71',
		},
	},
	empty: {
		color: '#2ECC71',
		':focus': {
			color: '#2ECC71',
		},
	},
};

/*
 -------------------------------
 Class
 -------------------------------
 */

class StripeIban extends Component {

	static get propTypes() {
		return {
			name: PropTypes.string,
			required: PropTypes.bool,
			options: PropTypes.object,
			afterChange: PropTypes.func,
		}
	}

	static get defaultProps() {
		return {
			required: false
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			changed: false,
			error: null,
			token: null
		};
	}

	get token() {
		return this.state.token;
	}

	get currency() {
		return 'dkk';
	}

	handle() {
		return new Promise((resolve, reject) => {
			// resolve if not required and not changed
			if (!this.props.required && !this.state.changed) {
				return resolve();
			}

			// remove previous errors
			this.setState({error: null});

			stripe.createToken(this.iban, {currency: this.currency}).then(({token, error}) => {
				// reject if error
				if (error) {
					return this.setState({error: error.message}, () => reject(error));
				}

				// update token state and resolve
				this.setState({token: token}, () => resolve(token));
			});
		});
	}

	onChange = (e) => {
		if (!this.state.changed && typeof this.props.afterChange === 'function') {
			this.props.afterChange();
		}

		this.setState({
			changed: true,
			error: e.error ? e.error.message : null
		});
	};

	componentDidMount() {
		const elements = stripe.elements();
		const iban = this.iban = elements.create("iban", deepAssign({}, defaultOptions, this.props.options));

		iban.addEventListener("change", this.onChange);
		iban.mount(this.bodyElement);
	}

	renderBody() {
		return (
			<div ref={el => this.bodyElement = el} className="iban-body"></div>
		);
	}

	renderToken() {
		if (typeof this.props.name !== "string") {
			return;
		}

		if (this.state.token == null) {
			return;
		}

		return (
			<input type="hidden" name={this.props.name} value={this.state.token.id}/>
		);
	}

}

module.exports = StripeIban;



// WEBPACK FOOTER //
// ./resources/js/components/abstract/StripeIban.js